import { ExternalLink } from "lucide-react";
import React from "react";

interface TermsAcceptanceProps {
	termsAccepted: boolean;
	onTermsChange: (accepted: boolean) => void;
}

export default function TermsAcceptance({ termsAccepted, onTermsChange }: TermsAcceptanceProps) {
	const termsUrl = process.env.REACT_APP_TERMS_URL || "#";
	const privacyUrl = process.env.REACT_APP_PRIVACY_URL || "#";

	return (
		<div className="space-y-4 p-6 bg-white/80 backdrop-blur-sm rounded-xl border border-gray-200 shadow-sm">
			<div className="space-y-3">
				<h3 className="text-lg font-semibold text-gray-900">Before we continue</h3>
				<p className="text-sm text-gray-600">Please review and accept our terms to proceed.</p>

				<div className="flex items-start gap-3">
					<input
						type="checkbox"
						id="terms-acceptance-checkbox"
						checked={termsAccepted}
						onChange={(e) => onTermsChange(e.target.checked)}
						className="mt-1 h-4 w-4 text-orange-500 border-gray-300 rounded focus:ring-orange-500 focus:ring-2 cursor-pointer"
					/>
					<label
						htmlFor="terms-acceptance-checkbox"
						className="text-sm text-gray-700 leading-relaxed cursor-pointer"
					>
						I agree to the{" "}
						<a
							href={termsUrl}
							target="_blank"
							rel="noopener noreferrer"
							className="text-orange-600 hover:text-orange-700 underline font-medium inline-flex items-center gap-1"
						>
							Terms of Service
							<ExternalLink className="w-3 h-3" />
						</a>{" "}
						and{" "}
						<a
							href={privacyUrl}
							target="_blank"
							rel="noopener noreferrer"
							className="text-orange-600 hover:text-orange-700 underline font-medium inline-flex items-center gap-1"
						>
							Privacy Policy
							<ExternalLink className="w-3 h-3" />
						</a>
					</label>
				</div>

				{!termsAccepted && (
					<div className="flex items-center gap-2 text-amber-600 bg-amber-50 px-3 py-2 rounded-lg border border-amber-200 mt-3">
						<span className="text-sm font-medium">
							Please ensure you have read and accepted the terms to continue
						</span>
					</div>
				)}
			</div>
		</div>
	);
}
